export const ERROR_TYPES = {
  UNAUTHORIZED: "unauthorized",
  ACTIVE_SESSION_RUNNING: "activeSessionRunning",
  BAD_REQUEST: "badRequest",
};

export const getErrorType = ({ status, code }) => {
  if (code === "E_UNAUTHORIZED" || status === 401) {
    return ERROR_TYPES.UNAUTHORIZED;
  }

  if (code === "ACTIVE_SESSION_RUNNING" || status === 409) {
    return ERROR_TYPES.ACTIVE_SESSION_RUNNING;
  }

  if (code === "E_BAD_REQUEST" || status === 400) {
    return ERROR_TYPES.BAD_REQUEST;
  }

  return null;
};

export const handleError = ({
  status,
  code,
  message,
  onUnauthorized,
  onActiveSessionRunning,
  onBadRequest,
}) => {
  const errorType = getErrorType({ status, code });

  switch (errorType) {
    case ERROR_TYPES.UNAUTHORIZED:
      onUnauthorized?.(message);
      return true;

    case ERROR_TYPES.ACTIVE_SESSION_RUNNING:
      onActiveSessionRunning?.(message);
      return true;

    case ERROR_TYPES.BAD_REQUEST:
      onBadRequest?.(message);
      return true;

    default:
      return false;
  }
};

export const getErrorPageProps = (type, message) => {
  switch (type) {
    case ERROR_TYPES.UNAUTHORIZED:
    case ERROR_TYPES.ACTIVE_SESSION_RUNNING:
    case ERROR_TYPES.BAD_REQUEST:
      return {
        title: "Access Denied",
        subtitle: message,
        showHeader: false,
      };

    default:
      return null;
  }
};